export const isObject = (value) => {
    return !!(value && typeof value === "object" && !Array.isArray(value));
};

export const isArray = (value) => {
    return !!(value && Array.isArray(value));
};